<template>
  <div
    style="
      overflow-y: auto;
      height: 100%;
      background-color: #f6f6f6;
      padding: 10px;
    "
  >
    <van-pull-refresh v-model="state.isRefresh" @refresh="onRefresh">
      <van-list
        v-model:loading="state.loading"
        v-model:error="state.error"
        :error-text="state.errorMsg"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          v-for="item in state.listData"
          :key="item"
          style="
            background-color: #fff;
            border-radius: 10px;
            padding: 10px;
            position: relative;
            font-size: 13px;
            margin-bottom: 10px;
          "
          @click="toDetail(item)"
        >
          <ul
            style="
              display: flex;
              align-items: center;
              padding-bottom: 10px;
              border-bottom: 1px solid #e2e2e2;
            "
          >
            <li style="flex: 1; font-weight: 600; font-size: 14px">
              {{ item.customer_name }}
            </li>
            <template v-if="[1, 2].includes(item.status)">
              <van-tag type="danger" v-if="item.is_arrearage">欠款</van-tag>
              <c_status
                arrName="salaryapply_status"
                :value="item.status"
                :leftSize="5"
              />
            </template>
            <template v-else>
              <template v-if="item.step == 2">
                <van-tag type="danger" v-if="item.is_arrearage">欠款</van-tag>
                <c_status
                  arrName="salaryapply_step"
                  value="2-1"
                  :leftSize="5"
                  v-if="item.is_arrearage"
                />
                <c_status
                  arrName="salaryapply_step"
                  value="2-2"
                  :leftSize="5"
                  v-else
                />
              </template>
              <c_status
                v-else
                arrName="salaryapply_step"
                :value="item.step"
                :leftSize="5"
              />
            </template>
          </ul>
          <ul style="margin-top: 10px">
            {{
              item.name
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <text style="color: #a2a2a2">发放人数：</text>
            {{
              item.employee_num
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <text style="color: #a2a2a2">申请人：</text>
            {{
              item.add_admin_name
            }}
            <text v-if="item.add_department_name">{{
              "/" + item.add_department_name
            }}</text>
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <text style="color: #a2a2a2">申请时间：</text>
            {{
              item.create_time
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <text style="color: #a2a2a2">薪资所属期：</text>
            {{
              item.month
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <text style="color: #a2a2a2">约定发薪日期：</text>
            {{
              item.pay_date
            }}
          </ul>
          <div
            style="
              position: absolute;
              right: 10px;
              bottom: 10px;
              box-shadow: 0 0 3px 1px #e2e2e2;
              padding: 20px;
              background-color: #fff;
              border-radius: 5px;
            "
          >
            <ul style="text-align: center; font-size: 16px">
              <c_money :value="item.money" bold />
            </ul>
            <ul style="text-align: center; color: #a2a2a2; font-size: 10px">
              发放金额
            </ul>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-popup
      v-model:show="state.showDetail"
      position="right"
      teleport="body"
      style="width: 100%; height: 100%"
    >
      <c_Check
        v-if="state.showDetail"
        :id="state.selectItem?.id"
        @close="onCheckClose"
      ></c_Check>
    </van-popup>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { check_list } from "@/http/api";
import constant from "@/utils/constant";
import c_Check from "./Check.vue";
export default {
  components: {
    c_Check,
  },
  setup() {
    const state = reactive({
      params: {
        limit: constant.pageSize,
        page: 0,
        sort_value: "desc",
      },
      listData: [],
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      state.loading = true;
      state.params.page++;

      check_list(state.params)
        .then((res) => {
          state.loading = false;
          state.isRefresh = false;
          if (res.status == 200) {
            const list = res.data.data?.list;
            state.listData = [...(state.listData || []), ...list];

            if (list.length < constant.pageSize) {
              state.finished = true;
            }
          }
        })
        .catch((err) => {
          state.error = true;
          state.errorMsg = err;
          state.loading = false;
          state.isRefresh = false;
        });
    };

    const onRefresh = () => {
      state.isRefresh = true;
      state.params.page = 0;
      state.listData = [];
      state.finished = false;
      onLoad();
    };

    const toDetail = (item) => {
      state.selectItem = item;
      state.showDetail = true;
    };

    const onCheckClose = (isRef) => {
      state.showDetail = false;
      if (isRef) onRefresh();
    };
    return { state, toDetail, onLoad, onRefresh, onCheckClose };
  },
};
</script>
<style scoped></style>
